import { Component } from '@angular/core'

@Component({
	selector: 'app-system-lockscreen-page',
	templateUrl: './lockscreen.component.html',
})
export class LockscreenPage {}
